import { Box, Masonry, RouterTabContent, RouterTabs, Typography } from '@forgeglobal/design-framework'
import { DashboardAccounts } from 'components/dashboard/DashboardAccounts'
import { DashboardIssuers } from 'components/dashboard/DashboardIssuers'
import { DashboardOpportunities } from 'components/dashboard/DashboardOpportunities'
import { Reminders } from 'components/dashboard/Reminders'
import React, { Fragment } from 'react'

export const Dashboard: React.FC = () => {
  const sections = [<Reminders key="reminders" />]

  return (
    <Fragment>
      <Box p={3} pt={4}>
        <Typography variant="h4" color="secondary" style={{ textTransform: 'none' }}>
          Dashboard
        </Typography>
      </Box>

      <RouterTabs>
        <RouterTabContent label="reminders">
          <Box p={1} m={1}>
            <Masonry items={sections} />
          </Box>
        </RouterTabContent>
        <RouterTabContent label="opportunities">
          <DashboardOpportunities />
        </RouterTabContent>
        <RouterTabContent label="accounts">
          <DashboardAccounts />
        </RouterTabContent>
        <RouterTabContent label="issuers">
          <DashboardIssuers />
        </RouterTabContent>
      </RouterTabs>
    </Fragment>
  )
}
